module.exports = __webpack_public_path__ + "img/visa.2d474798eabea3279304607d259ebc6e.svg";